import { gql } from '@apollo/client';

export const CREATE_RESIDENT_GROUP = gql`
  mutation createResidentGroup($createResidentGroupInput: CreateResidentGroupInput!) {
    createResidentGroup(createResidentGroupInput: $createResidentGroupInput) {
      id
    }
  }
`;

export const REMOVE_RESIDENT_GROUP = gql`
  mutation removeResidentGroup($id: String!) {
    removeResidentGroup(id: $id)
  }
`;

export const UPDATE_RESIDENT_GROUP = gql`
  mutation updateResidentGroup($data: UpdateResidentGroupInput!) {
    updateResidentGroup(updateResidentGroupInput: $data) {
      id
    }
  }
`;
